import { gql } from "@apollo/client";
import { SEARCH_ITEM_FIELDS } from "../fragments/searchItem";

const search = gql`
  ${SEARCH_ITEM_FIELDS}
  query Search(
    $query: String!
    $first: Int!
    $after: String
    $retry: Boolean
    $id: ID
    $useOwnSize: Boolean
    $skipPersonalization: Boolean
    $type: Search_Type
  ) {
    search(
      query: $query
      first: $first
      after: $after
      retry: $retry
      id: $id
      useOwnSize: $useOwnSize
      skipPersonalization: $skipPersonalization
      type: $type
    ) {
      items {
        searchID
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            ...SEARCH_ITEM_FIELDS
          }
          cursor
        }
        explanation
      }
      partial
      result
      categoryLandingInfo {
        title
        merchandising {
          title
          type
          items {
            image
            text
            searchQuery
            brandID
          }
        }
        filters {
          image
          text
          searchQuery
        }
        hasMoreFilter
      }
      type
      curation {
        explanationTitle
        explanation
        suggestions {
          title
          explanation
          searchQuery
          searchID
          items {
            ...SEARCH_ITEM_FIELDS
          }
          outfit {
            imageURL
            handle
          }
        }
      }
    }
  }
`;
export default search;
